export default __webpack_public_path__ + "static/media/bg8.c01ebcd4.jpg";